module.exports = ".pointer {\n  cursor: pointer; }\n\n.table .filter-row th {\n  position: relative; }\n  .table .filter-row th .clear {\n    position: absolute;\n    top: 0.55rem;\n    right: 0.76rem;\n    cursor: pointer; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/messages/overview.component.scss
// module id = 573
// module chunks = 1